module.exports = __webpack_public_path__ + "static/media/Lead Magnet landing Page.8acff012.pdf";